export default __webpack_public_path__ + "static/media/891.37659093.png";